<template>
  <div class="dialog-container">
    <el-row :gutter="18">
      <el-col :span="24">
        <find-client-by-ssn @clientFound="continueApplication" @clientNotFound="clientNotFound"></find-client-by-ssn>
      </el-col>
    </el-row>
    <el-dialog
      title="No Client Found"
      :visible.sync="showNoClientFoundDialog"
    >
      <span>No client was found having SSN: <strong>{{ searchedSSN }}</strong></span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showNoClientFoundDialog = false">Cancel</el-button>
        <el-button type="primary" @click="startNewApplication">Start New Application</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FindClientBySsn from '@/components/widgets/FindClientBySSN.vue';

export default {
  data() {
    return {
      showNoClientFoundDialog: false,
      searchedSSN: null,
    };
  },
  methods: {
    clientNotFound(ssn) {
      this.searchedSSN = ssn;
      this.showNoClientFoundDialog = true;
    },
    startNewApplication() {
      this.showNoClientFoundDialog = false;
      this.$emit('startNewApplication', this.searchedSSN);
    },
    continueApplication(clientData) {
      this.showNoClientFoundDialog = false;
      this.$emit('continueApplication', clientData);
    },
  },
  components: {
    FindClientBySsn,
  },
};

</script>
